import React, { useEffect, useState } from "react";
import MiniDrawer from "../../tools/MiniDrawer";
import {
    Box,
    Breadcrumbs,
    Link,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Pagination,
    Stack,
} from "@mui/material";
import axios from "axios";
import { useMsal } from "@azure/msal-react";

interface HistoriqueRow {
    HIST_ID: number;
    HIST_NAME: string;
    HIST_DATETIME: string;
    HIST_USER: string;
}

interface HistoriqueData {
    Pagination: {
        totalRecords: number;
        totalPages: number;
        currentPage: number;
        nextPage: number;
        previousPage: number;
    };
    HistoriqueRow_LENGTH: number;
    HistoriqueRow: HistoriqueRow[];
}

const Historique: React.FC = () => {
    const { instance, accounts, inProgress } = useMsal();

    const [widthDrawer, setWidthDrawer] = useState("");

    const [data, setData] = useState<HistoriqueRow[]>([]);
    const [page, setPage] = useState(1);
    const [pageSize] = useState(20);
    const [totalPages, setTotalPages] = useState(1);

    const fetchData = async (pageNumber: number) => {
        try {
            let token = instance?.getAllAccounts()[0].idToken ?? "";

            const response = await axios.get(
                "https://api.prod.gcp.toutfaire.com/v1/gw/v1/apitools/ARTLAD/gethistoric",
                {
                    params: {
                        pageSize: pageSize,
                        pageNumber: pageNumber,
                    },
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            const result: HistoriqueData = response.data.p_data;
            console.log(response);
            setData(result.HistoriqueRow);
            setTotalPages(result.Pagination.totalPages);
        } catch (error) {
            console.error("Erreur lors de la récupération des données :", error);
        }
    };


    useEffect(() => {
        fetchData(page);
    }, [page]);

    const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
    };

    return (
        <MiniDrawer width={widthDrawer} setWidth={setWidthDrawer}>
            <Box style={{ flexGrow: 1, padding: "85px 0px 0px 32px" }}>
                <div style={{ flexGrow: 1, alignItems: "center", width: widthDrawer }}>
                    {/* Header / breadcrumbs */}
                    <Breadcrumbs aria-label="breadcrumb">
                        <Link underline="hover" color="inherit" href="/">
                            Accueil
                        </Link>
                        <Typography color="text.primary">
                            Historique LAD - Exclusivité web
                        </Typography>
                    </Breadcrumbs>

                    {/* Title */}
                    <Typography
                        variant="h3"
                        style={{
                            margin: "10px 10px 10px 0",
                            fontWeight: "bold",
                            fontSize: "32px",
                        }}
                    >
                        Historique LAD - Exclusivité web
                    </Typography>

                    {/* Tableau de données */}
                    <TableContainer component={Paper} style={{ marginTop: "20px", maxWidth: "90%" }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell><b>Nom d'historique</b></TableCell>
                                    <TableCell><b>Date</b></TableCell>
                                    <TableCell><b>Utilisateur</b></TableCell>
                                    <TableCell><b></b></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.map((row, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{row.HIST_NAME}</TableCell>
                                        <TableCell>{row.HIST_DATETIME}</TableCell>
                                        <TableCell>{row.HIST_USER}</TableCell>
                                        <TableCell>
                                            <button
                                                onClick={() => {
                                                    // page détail
                                                }}
                                            >
                                                Détail
                                            </button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Stack spacing={2} style={{ marginTop: "20px" }}>
                        <Pagination
                            count={totalPages}
                            page={page}
                            onChange={handleChange}
                            color="primary"
                        />
                    </Stack>
                </div>
            </Box>
        </MiniDrawer>
    );
};

export default Historique;